import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Table } from 'react-bootstrap';
import { FormattedNumber } from 'react-intl';
import FormattedDateTime from '../format/FormattedDateTime';
import AddCryptoForm from './AddCryptoForm';
import color from '../../config/color';

export default class CryptoModal extends Component {
  /*
    This component is showing info about a crypto currency in a modal.
  */

  constructor(props) {
    super(props);

    // Initial state
    this.state = {
      show: false
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    // Update the modal when new props arrive.
    this.setState({ show: newProps.show });
  }

  hideModal = () => {
    this.props.hide();
    this.setState({ chartLoaded: false });
  };

  render() {
    const { crypto } = this.props;
    return crypto ? (
      <Modal show={this.state.show} onHide={this.hideModal}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">{crypto.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table hover responsive size="sm">
            <tbody className="no-border">
              <tr>
                <td>Siste kurs NOK</td>
                <td>
                  <FormattedNumber
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                    value={crypto.priceNok}
                  />
                </td>
              </tr>
              <tr>
                <td>Oppdatert</td>
                <td>
                  <FormattedDateTime
                    timestamp={crypto.lastUpdatedTimestamp}
                    type="Crypto"
                    showClockPrefix
                  />
                </td>
              </tr>
              <tr>
                <td>Siste time</td>
                <td className={color.getClassName(crypto.hourlyChange)}>
                  {crypto.hourlyChange ? (
                    <FormattedNumber // eslint-disable-next-line
                      style="percent"
                      minimumFractionDigits={2}
                      maximumFractionDigits={2}
                      value={crypto.hourlyChange / 100}
                    />
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
              <tr>
                <td>Siste dag</td>
                <td className={color.getClassName(crypto.dailyChange)}>
                  {crypto.dailyChange ? (
                    <FormattedNumber // eslint-disable-next-line
                      style="percent"
                      minimumFractionDigits={2}
                      maximumFractionDigits={2}
                      value={crypto.dailyChange / 100}
                    />
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
              <tr>
                <td>Siste uke</td>
                <td className={color.getClassName(crypto.weeklyChange)}>
                  {crypto.weeklyChange ? (
                    <FormattedNumber // eslint-disable-next-line
                      style="percent"
                      minimumFractionDigits={2}
                      maximumFractionDigits={2}
                      value={crypto.weeklyChange / 100}
                    />
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Body>
          <AddCryptoForm cryptoId={crypto.cryptoId} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={this.hideModal}>
            Lukk
          </Button>
        </Modal.Footer>
      </Modal>
    ) : null;
  }
}

CryptoModal.propTypes = {
  crypto: PropTypes.objectOf(PropTypes.any),
  hide: PropTypes.func.isRequired
};
